export default {
  special: {
    header: 'Special Event Insurance',
    body: `<div class="title-sm">Ensure the Success of Your Big Day</div>
<p>Anniversaries, birthday celebrations, graduation parties, and weddings -
these are all special events that celebrate important moments in a person’s life.
Planning such an event often involves a lot of time, money, and effort,
all in the hopes that everything goes as expected.</p>

<p>Special Event Insurance from SIG & Associates is designed to provide you with peace of mind
and financial protection in the event you have to cancel your special plans due to adverse
weather conditions or a natural disaster. Most policies also cover cancellation when serious
injury or illness prevents a key participant from attending the event.</p>

<p>Since Special Event Insurance is designed on an individual basis, it’s important to
discuss your specific insurance needs with a professional. Contact today to learn more.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  wedding: {
    header: 'Wedding Insurance',
    body: `<p>Weddings are one of the most important events in life—and they're among the most expensive,
too, with the average wedding now costing over $26,000. And, that's before the honeymoon,
which tends to be another $5,000 all by itself. Given the sheer amount of time, effort, money,
and planning that goes into a wedding, it makes sense to protect your funds invested in this event
and make sure that unexpected problems don't result in the loss of your entire investment.</p>

<p>Before you begin shopping for wedding insurance, though, there are a few
important things to know—like what parts of the event are covered and how liability can come into play.</p>

<div class="title-sm">Special Events Covered by Wedding Insurance</div>

<p>Here are the parts of a wedding that most policies cover:</p>

<ul>
<li><b>Wedding Venues:</b> While most permanent wedding venues (such as churches) have their own liability coverage,
many weddings take place in unusual areas. In fact, about a quarter of all weddings are considered
'destination weddings' and are held in a non-traditional wedding venue. Unfortunately, unforeseen problems
like weather, damage to the wedding site, or companies shutting down can make a chosen location inaccessible.</li>
<li><b>No-Shows:</b> Most vendors try to show up to every event, but for whatever reason, there are times when
they can't make it. One-time event insurance can reimburse you for any losses
suffered as a result of their failure to attend.</li>
<li><b>Injury and Illness:</b> If someone vital to the wedding—say, the bride—comes down ill or
injured just before the event, there's a good chance it's going to be postponed until
they're feeling better. Wedding insurance can cover these delays.</li>
<li><b>Job and Military Deployment:</b> Similarly, if someone is forced to move
(whether they're being deployed overseas as part of the military or simply moving to another city along with their company),
delays can occur—and just like with illness and injury, wedding insurance can cover this.</li>
</ul>

<p>It's important to note that most plans don't cover losses due to either
party deciding to cancel the wedding due to a change of heart.</p>

<div class="title-sm">Event Liability Insurance</div>

<p>Weddings should also have basic liability coverage in case anyone is hurt during the event.
For example, guests may have allergies to foods or perfumes brought in, or people
trying to move a large object as part of the ceremony could trip and fall.
The right coverage can ensure that a wedding won't end with the bride and groom facing a
lawsuit they'll have to pay out of pocket to defend. Call SIG & Associates
today for a free quote and more information.</p>

<ul>
<li><a href="http://www.costofwedding.com/" target="_blank"><b>"Average Wedding Cost."</b>
Average Wedding Cost in the United States. Accessed April 18, 2016. http://www.costofwedding.com/</a></li>
<li><a href="http://experience.usatoday.com/beach/story/caribbean/2014/06/04/caribbean-value-honeymoon/9970857/" target="_blank">
<b>"How to save on a Caribbean Honeymoon."</b> Accessed April 18, 2016.
http://experience.usatoday.com/beach/story/caribbean/2014/06/04/caribbean-value-honeymoon/9970857/</a></li>
<li><a href="http://www.prnewswire.com/news-releases/the-knot-the-1-wedding-site-releases-2014-real-weddings-study-statistics-300049675.html."
target="_blank"><b>"The Knot, The #1 Wedding Site, Releases 2014 Real Weddings Study Statistics."</b>Accessed April 18, 2016. </a></li>
</ul>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  other: {
    header: 'Other Services',
    body: `<div class="title-sm">Going the Extra Mile for Your Convenience</div>

<p>Getting the right permit or license for your business or personal use shouldn’t be a hassle.
With a variety of different Licensing and Permit options available under one roof,
SIG & Associates can take care of most of the work for you.</p>

<div class="title-sm">Permit Services</div>
<p>SIG & Associates provides Permit services for the following:</p>

<ul>
<li>Residential and Commercial Buildings and Structures</li>
<li>Building and Zoning Codes</li>
<li>Building Safety</li>
<li>Fire Prevention</li>
</ul>

<div class="title-sm">License Services</div>
<p>In addition, our License Services can keep your operations legal and up to date with
a range of licensing options for many business establishments, including:</p>

<ul>
<li>Massage Therapists</li>
<li>Home-Based Businesses</li>
<li>Pawnbrokers</li>
<li>Haul for Hire Services</li>
<li>Bulk Storage Companies</li>
<li>Manufacturing and Warehousing Services</li>
</ul>

<div class="title-sm">Notary Services</div>
<p>For your convenience, we also offer the signatory services of an authorized
Notary during all business hours for notarizing legal documents,
including a signing agent for notarizing mortgage and real estate documents.</p>
<p>Find an additional insurance service that’s right for your individual or business needs from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/additionalHelper.js